// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  visitRowId: __t.u64().primaryKey().name("visit_row_id"),
  worldId: __t.u64().name("world_id"),
  visitor: __t.identity(),
  visitCount: __t.u32().name("visit_count"),
  lastAt: __t.timestamp().name("last_at"),
});
